export var TEXT_BUTTON_FONT_TYPES = Object.freeze({
  body: 'body',
  bodyHeading: 'bodyHeading',
  bodySmall: 'bodySmall',
  bodySmallHeading: 'bodySmallHeading'
});